import axios from "axios";

// Determine the baseURL dynamically
const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3005/api" // Localhost for development
    : "https://react.niketgroup.in/api"; // Production URL

// Create an Axios instance with default configurations
const apiService = axios.create({
  baseURL, // Dynamic baseURL
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Attach Token Automatically Before Each Request
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve token from localStorage
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Add Bearer token
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Global Response Interceptor (Handles Errors & Unauthorized Access)
apiService.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data?.message || "An error occurred";

    // If Unauthorized (401), clear token & redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem("token"); // Remove expired/invalid token
      window.location.href = "/login"; // Redirect to login page
    }

    return Promise.reject({ ...error.response?.data, message: errorMessage });
  }
);

// ✅ Utility Function to Set Token Manually
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem("token");
  }
};

export default apiService;
